import {
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { TranstationFactory } from 'src/app/core/translation.factory';
import { Address, AddressName } from 'src/app/models/address';
import { QuotationEApp } from 'src/app/models/quotation/quotation-eApp';
import { QuotationInsurerInfo } from 'src/app/models/quotation/quotation-insurer-info';
import { QuoteTransfer } from 'src/app/models/quoteTransfer/QuoteTransfer';
import { QuoteTransferConvert } from 'src/app/models/quoteTransfer/quoteTransferConvert';
import { TableValueModel } from 'src/app/models/save-model/table-value-model';
import { ActionType } from 'src/app/models/type/action.type.enum';
import { AddressType } from 'src/app/models/type/address.type.enum';
import { PersonalFactoryService } from 'src/app/services/personal-factory.service';
import { ProspectFactoryService } from 'src/app/services/prospect-factory.service';
import { ProspectService } from 'src/app/services/prospect.service';
import { QuotationFactoryService } from 'src/app/services/quotation-factory.service';
import { QuotationService } from 'src/app/services/quotation.service';
import { QuoteTransferService } from 'src/app/services/quoteTransfer.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FormValidateComponent } from 'src/app/shared/base-component/form-validate-component';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-preview-prospect',
  templateUrl: './preview-prospect.component.html',
  styleUrls: ['./preview-prospect.component.scss']
})
export class PreviewProspectComponent extends FormValidateComponent implements OnInit {

  // @Input() public item;
  item: any;
  action: ActionType;
  addressList: Array<Address>;
  address: Address = new Address();
  person: QuotationInsurerInfo;
  exceptAddressType: Array<AddressType>;
  prospect: any;
  payer: any;
  prospectAdderess: any;
  payerAdderess: any;
  quotationId: string;
  prosAdd:boolean = false;
  payAdd: boolean = false;
  personalId: string;
  downloadSelect: Array<TableValueModel>;
  type: string;
  
  private _prospectId;
  private addressLabel: AddressName;
  @Output() onSave: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private quotationService: QuotationService,
    private prospectFactoryService: ProspectFactoryService,
    private quotationFactoryService: QuotationFactoryService,
    private utilityService: UtilityService,
    private quoteTransferService: QuoteTransferService,
    private translate: TranstationFactory,
    private personalFactory: PersonalFactoryService,

  ) { super(); }

  ngOnInit() {
    console.log("type :",this.type)
    this.quotationId = this.quotationFactoryService.getQuotationId();
    this._prospectId = this.prospectFactoryService.getProspectId();
    this.personalId = this.item.personalId;
    this.callServiceQuotation();
     

  }

  private callServiceQuotation() {
    if(!this.quotationId || this.quotationId.indexOf(",")){
      this.quotationId = this.item.qtId?this.item.qtId:this.item.quotationId
      // this.quotationId = this.item.quotationId
    }
    if(!this._prospectId){
      this._prospectId = this.item.prospectId
    }
    this.quotationService.getProspectDetail(this.quotationId, this._prospectId).subscribe(({ prospect, payer }) => {
      this.prospect = prospect;
      this.payer = payer;
      this.prospectAdderess = this.prospect.address[0]
      this.payerAdderess = this.payer.address[0]
      if(this.prospect.address.length > 0){
        this.prosAdd = true
      }
      if(this.payer.address.length > 0){
        this.payAdd = true
      }
    });
  }

  editLead(personalId: any,quotationId:any) {
    this.personalFactory.removePersonalId()
    this.utilityService.routerNavigate('/home/sales-product/new-customer', {
      personalId: personalId,
      quotationId: quotationId
    });
    this.hide('close');
  }


  close() {
    this.hide('close');
  }

  createForm() {
   
  }

  onSubmit() {
    
  }

  convert(item) {
    const val = new TableValueModel();
    this.downloadSelect = new Array<TableValueModel>();
    val.quotationId = item.quotationId;
    val.productCode = item.productCode;
    val.quotationNo = item.quotationNo;
    val.gender = item.gender;
    val.age = item.yearOfAge;
    val.sumAssure = item.sumAssure;
    this.downloadSelect.push(val);
    this.quotationService.saveTableValue(this.downloadSelect).subscribe(async value => {
      this.quoteTransferService.convertCase(this.mappingQuoteTransferConvert(item, "ConvertCase")).subscribe(resMergeCase => {
        if (resMergeCase.status == "Success") {
          if (resMergeCase.data.outputs.data.status != "Error") {
            this.quotationService.updateQuotationEapp(this.mappingQuotationEapp(resMergeCase.data)).subscribe(resUpdate => {
              if (resUpdate.result) {
                // document.location.href = resMergeCase.data.outputs.data.link;
                document.location.href = environment.redirectEpos + 'application/' + resMergeCase.data.outputs.data.appNo;
              }
            });
          } else {
            if (resMergeCase.status != "Error") {
              Swal.fire({
                title: this.translate.get('warning'),
                text: '',
                type: 'error',
                confirmButtonText: this.translate.get('button.close')
              });
            }
          }
        }
      });
    });


  }

  merge(item) {
    Swal.fire({
      title: this.translate.get('warning'),
      text: this.translate.get('warning_merge'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.get('button.ok'),
      cancelButtonText: this.translate.get('button.cancel'),
    }).then((result) => {
      if (result.value == true) {
        const val = new TableValueModel();
        this.downloadSelect = new Array<TableValueModel>();
        val.quotationId = item.qtId;
        val.productCode = item.productCode;
        val.quotationNo = item.qtCode;
        val.gender = this.prospect.gender;
        val.age = this.prospect.yearOfAge;
        val.sumAssure = item.sumAssure;
        this.downloadSelect.push(val);
        this.quotationService.saveTableValue(this.downloadSelect).subscribe(async value => {
          this.quoteTransferService.mergeCase(this.mappingQuoteTransfer(item, "MergeCase")).subscribe(resMergeCase => {
            if (resMergeCase.status == "Success") {
              if (resMergeCase.data.outputs.data.status != "Error") {
                this.quotationService.updateQuotationEapp(this.mappingQuotationEapp(resMergeCase.data)).subscribe(resUpdate => {
                  if (resUpdate.result) {
                    // document.location.href = resMergeCase.data.outputs.data.link;
                    document.location.href = environment.redirectEpos + 'application/' + resMergeCase.data.outputs.data.appNo;
                  }
                });
              } else {
                if (resMergeCase.status != "Error") {
                  Swal.fire({
                    title: this.translate.get('warning'),
                    text: this.translate.get('warning_merge_error'),
                    type: 'warning',
                    confirmButtonText: this.translate.get('button.close')
                  }).then((result) => {
                    this.quotationService.updateQuotationEapp(this.mappingQuotationFor404(resMergeCase.data)).subscribe(resUpdate => {
                      if (resUpdate.result) {
                        location.reload();
                      }
                    });
                  });
                }
              }
            }
          });
        });
      }
    });
  }

  mappingQuoteTransferConvert(item, category): QuoteTransferConvert {
    return {
      engineType: "Type5",
      inputs: {
        quotationNo: item.quotationNo,
        prospectCustomerId: item.prospectId?item.prospectId:this.prospectFactoryService.getProspectId(),
        language: localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE') == 'en' ? 'EN-en' : 'TH-th'
      },
      requestedServiceCategory: category
    }
  }

  mappingQuotationEapp(val): QuotationEApp {
    return {
      applicationNumber: val.outputs.data.appNo,
      linkEapp: val.outputs.data.link,
      quotationNo: val.outputs.data.quotationNo,
      status: val.outputs.data.appStatus == "Opened" ? "Converted" : val.outputs.data.appStatus,
      timeStamp: new Date(val.outputs.data.timestamp)
    }
  }

  private hide(msg: string) {
    this.modalService.onHide.emit(msg);
    this.bsModalRef.hide();
  }

  mappingQuoteTransfer(item, category): QuoteTransfer {
    return {
      engineType: "Type5",
      inputs: {
        quotationNo: item.quotationNo,
        appNo: item.applicationNumber,
        prospectCustomerId: item.prospectId?item.prospectId:this.prospectFactoryService.getProspectId(),
        language: localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE') == 'en' ? 'EN-en' : 'TH-th'
      },
      requestedServiceCategory: category
    }
  }

  mappingQuotationFor404(item): QuotationEApp {
    return {
      applicationNumber: null,
      linkEapp: null,
      quotationNo: item.inputs.quotationNo,
      status: "Completed",
      timeStamp: new Date()
    }
  }

}
